"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCreatorBase = void 0;
var core_1 = require("@attensi/core");
var urls_1 = require("@attensi/urls");
var requester_1 = require("../base/requester");
var base_1 = require("../base/base");
exports.createCreatorBase = function (args) {
    var _a;
    var requester = requester_1.createRequester({
        baseURL: urls_1.urls.creatorServer((args === null || args === void 0 ? void 0 : args.environment) || undefined) + "/api",
        headers: {
            common: (_a = {},
                _a[base_1.Header.CONTENT_TYPE] = 'application/json; charset=utf-8',
                _a),
        },
    });
    var accessors = {
        get access_token() {
            return requester.getAccessToken();
        },
        set access_token(token) {
            requester.setAccessToken(token);
        },
        get creator_base_url() {
            return requester.getBaseUrl();
        },
        set creator_base_url(url) {
            requester.setBaseUrl(url);
        },
        get company_name_key() {
            return requester.getHeader(base_1.Header.COMPANY_NAME_KEY);
        },
        set company_name_key(companyNameKey) {
            requester.setHeader(base_1.Header.COMPANY_NAME_KEY, companyNameKey);
        },
        get environment() {
            return urls_1.urlToEnvironment(requester.getBaseUrl(), 'creatorServer');
        },
        set environment(environment) {
            requester.setBaseUrl(urls_1.urls.creatorServer(environment) + "/api");
        },
    };
    if (args) {
        if (args.access_token) {
            accessors.access_token = args.access_token;
        }
        if (args.company_name_key) {
            accessors.company_name_key = args.company_name_key;
        }
        if (args.creator_base_url) {
            accessors.creator_base_url = args.creator_base_url;
        }
    }
    return {
        requester: requester,
        accessors: accessors,
    };
};
//# sourceMappingURL=creatorBase.js.map